const MAPBOX_ACCESS_TOKEN = typeof drupalSettings !== 'undefined' && typeof drupalSettings.mapbox_access_token !== 'undefined' ? drupalSettings.mapbox_access_token : 'pk.eyJ1IjoibGVvcGlhc3RyYSIsImEiOiJja2ViNDJiYjUwNTh0MnlsZW5ibW9tbXlzIn0.DZy7X6n_JeJpU3pUhiv-Yg';
const MAPBOX_ZOOM_LEVEL = 10;
const MAPBOX_SKIN = 'outdoors-v11';

export {
  MAPBOX_ACCESS_TOKEN,
  MAPBOX_ZOOM_LEVEL,
  MAPBOX_SKIN
}
